import { cn } from "@/lib/utils";
import { useSidebarContext } from "@/hooks/use-sidebar-context";
import { useLayoutStyle } from "@/hooks/use-layout-style";

interface StickyActionBarProps {
  children: React.ReactNode;
  className?: string;
}

export function StickyActionBar({ children, className }: StickyActionBarProps) {
  const { collapsed } = useSidebarContext();
  const { style } = useLayoutStyle();
  const isSidebar = style !== "legacy";

  return (
    <div
      className={cn(
        "fixed bottom-0 right-0 left-0",
        isSidebar && (collapsed ? "lg:left-16" : "lg:left-72"),
        "bg-background border-t border-border p-4",
        "flex items-center gap-3 z-20",
        "shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]",
        "transition-all duration-300",
        className
      )}
    >
      {children}
    </div>
  );
}
